export const insuranceKeys = {
    HOME_CONTENT: 'HOME_CONTENT',
    HOUSE: 'HOUSE',
    HOLIDAY_HOME: 'HOLIDAY_HOME',
    CAR: 'CAR',
    ROADSIDE_ASSIST: 'ROADSIDE_ASSIST',
    BIKE: 'BIKE',
    MOPED: 'MOPED',
    TRAILER_CARAVAN: 'TRAILER_CARAVAN',
    TRAVEL: 'TRAVEL',
    BOAT: 'BOAT',
    ACCIDENT: 'ACCIDENT',
    DOG: 'DOG',
    CAT: 'CAT',
    HORSE: 'HORSE'
};
